import type React from 'react';

import { Button } from '@change/ds-core-ui';

type Props = {
	responses: Array<{ id: string; decisionMaker: { id: string } }>;
	slug: string;
	trackReadResponseClick: (responseId: string) => void;
};

export const ReadResponse: React.FC<Props> = ({ responses, slug, trackReadResponseClick }) => {
	if (responses.length === 0) return null;

	const firstDmResponseId = responses[0].id;
	const firstDmResponseUrl = `/p/${slug}/responses/${firstDmResponseId}`;

	return (
		<div>
			<Button
				as="a"
				data-testid="read-response"
				data-qa="read-response"
				onClick={() => trackReadResponseClick(firstDmResponseId)}
				href={firstDmResponseUrl}
				target="_blank"
				variant="tertiary"
				size="x-small"
				className="text-typography-interactive"
			>
				Read Response
			</Button>
		</div>
	);
};
